import type { JSX } from 'react';
import { useMemo } from 'react';

import type { DefineSlots } from '../utils';
import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';
import { componentSlots, renderChild } from '~/components/layout/utils';
import { SlotsProvider } from '~/components/providers';
import { useTemplate } from '~/hooks';
import { useStore } from '~/store';
import { selectModal, setModal } from '~/store/modal';
import { ReportModal } from './report';

export const NAME = 'Modal';

export const Slots = componentSlots(NAME, {
  MODAL_BG: 'modalBg',
  MODAL_CONTENT: 'modalContent',
});

type SlotProps = DefineSlots<
  typeof Slots,
  {
    [Slots.MODAL_BG]: JSX.IntrinsicElements['div'];
    [Slots.MODAL_CONTENT]: JSX.IntrinsicElements['div'];
  }
>;

export interface Props extends React.PropsWithChildren, WithSlotProps {
  className?: string;
}

const ModalComponent = () => {
  const template = useTemplate(NAME);
  const modal = useStore(selectModal);

  const slots = useMemo<SlotProps>(() => {
    let content: JSX.Element | null = null;

    switch (modal?.id) {
      case 'ReportModal':
        content = <ReportModal {...modal.data} />;
        break;

      default:
        break;
    }

    return {
      [Slots.MODAL_BG]: {
        onClick: () => {
          setModal(null);
        },
      },
      [Slots.MODAL_CONTENT]: {
        children: content,
      },
    };
  }, [modal]);

  return modal ? <SlotsProvider slots={slots}> {renderChild(template)}</SlotsProvider> : null;
};

ModalComponent.displayName = NAME;

export const Modal = withSlot(ModalComponent);
